exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leaveNotice p[data-v-17a82c33],.leaveNotice ul[data-v-17a82c33]{font-size:16px}.leaveNotice .leaveNoticeLead[data-v-17a82c33]{margin:20px 0 30px;font-size:21px;font-weight:700;line-height:1.35;text-align:center}.leaveNotice .leaveNoticeCenter[data-v-17a82c33]{max-width:880px;margin:0 auto}.leaveNotice .leaveNoticeList[data-v-17a82c33]{padding:20px;background-color:#f7f7f7;border-radius:10px}.leaveNotice .leaveNoticeList li[data-v-17a82c33]{margin-left:15px}", ""]);

// exports
